var _path;
var _excluded = ["svgRef", "title"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import React from "react";
var SvgDelete = function SvgDelete(_ref) {
  var svgRef = _ref.svgRef,
    title = _ref.title,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "-61.3 -85.8 368.6 512",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M-41.1 168.5v186.8c0 39.1 31.7 70.9 70.9 70.9h186c39.1 0 70.9-31.7 70.9-70.9V168.5v-50.9H-40.1s-1 11.7-1 50.9zM195.3-41.8v-30c0-7.7-6.3-14-14-14H64.7c-7.7 0-14 6.3-14 14v30c0 7.7-6.3 14-14 14h-84c-7.7 0-14 6.3-14 14v67c0 7.7 6.3 14 14 14h340.6c7.7 0 14-6.3 14-14v-67c0-7.7-6.3-14-14-14h-84c-7.7 0-14-6.3-14-14zm-44 14H94.7c-7.7 0-14-6.3-14-14s6.3-14 14-14h56.7c7.7 0 14 6.3 14 14-.1 7.7-6.3 14-14.1 14z"
  })));
};
var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgDelete, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/delete.21c5c60a.svg";
export { ForwardRef as ReactComponent };